module.exports = __webpack_public_path__ + "static/media/cp4.2e37926e.png";